import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faQuestion } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _ from 'lodash';
import {connect} from "react-redux";
import Downshift from 'downshift';
import Modal from 'react-modal';

const InstallForm = class extends Component{
    source = axios.CancelToken.source();
    pickfields = [];
    reqFields = ['Customer_verbally_approved_layout__c','Does_the_work_match_the_plans__c','Roof_Work_Complete__c', 'Did_you_have_all_equipment_necessary__c',
        'Any_broken_tiles__c', 'Customer_knows_the_status_of_the_job__c', 'Roof_conduit_painted__c', 'Opti_map_picture_uploaded__c','Did_the_customer_sign_the_NEM_form__c' ,
        'Ready_for_final_inspection__c', 'All_Roof_photos_uploaded_cb__c', 'Final_walkthrough_completed_cb__c', 'Roof_Lead_Notes__c', 'Does_the_equipment_installed_match_the_p__c',
        'Solar_electrical_work_complete__c', 'Battery_install_completed__c', 'Did_you_have_all_equipment_necessary_E__c', 'Any_damage_to_siding_stucco__c',
        'Customer_knows_the_status_of_the_job_E__c', 'Wall_conduit_painted__c'
    ];

    componentDidMount(){
        window.scrollTo(0, 0);
        
        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/Install_Outcome__c;What_Was_The_Reason_For_Cancelling__c;Why_didn_t_CU_approve_layout__c;Why_doesn_t_the_work_match_the_plans__c;' +
            'What_roof_work_needs_to_be_completed_C__c;Reason_for_not_completing_roof_work_C__c;What_type_of_tech_needs_to_be_sent_out__c;Estimated_time_needed_to_finish_Roof_Ins__c;' +
            'Why_not_supplied_with_all_equipment__c;Why_customer_doesn_t_know_status_of_job__c;CAD_Errors__c;What_electrical_work_needs_to_be_comp__c;Reason_for_not_completing_SE_work__c;' +
            'Est_time_needed_to_finish_SE_install__c;What_type_of_battery__c;Why_was_power_not_restored_to_the_home__c;Trench_Inspection_Outcome__c',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        Install_Outcome__c: this.props.fieldJob.Install_Outcome__c,
        What_Was_The_Reason_For_Cancelling__c: this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c,
        Needs_follow_up__c: this.props.fieldJob.Needs_follow_up__c,
        Job_Notes__c: this.props.fieldJob.Job_Notes__c,
        Customer_verbally_approved_layout__c: this.props.fieldJob.Customer_verbally_approved_layout__c,
        Why_didn_t_CU_approve_layout__c: this.props.fieldJob.Why_didn_t_CU_approve_layout__c,
        Does_the_work_match_the_plans__c: this.props.fieldJob.Does_the_work_match_the_plans__c,
        Why_doesn_t_the_work_match_the_plans__c: this.props.fieldJob.Why_doesn_t_the_work_match_the_plans__c,
        Roof_Work_Complete__c: this.props.fieldJob.Roof_Work_Complete__c,
        What_roof_work_needs_to_be_completed_C__c: this.props.fieldJob.What_roof_work_needs_to_be_completed_C__c,
        Reason_for_not_completing_roof_work_C__c: this.props.fieldJob.Reason_for_not_completing_roof_work_C__c,
        What_type_of_tech_needs_to_be_sent_out__c: this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c,
        Estimated_time_needed_to_finish_Roof_Ins__c: this.props.fieldJob.Estimated_time_needed_to_finish_Roof_Ins__c,
        Did_you_have_all_equipment_necessary__c: this.props.fieldJob.Did_you_have_all_equipment_necessary__c,
        Why_not_supplied_with_all_equipment__c: this.props.fieldJob.Why_not_supplied_with_all_equipment__c,
        Any_broken_tiles__c: this.props.fieldJob.Any_broken_tiles__c,
        Did_you_have_enough_tiles_to_fix_broken__c: this.props.fieldJob.Did_you_have_enough_tiles_to_fix_broken__c,
        How_many_tiles_are_still_needed__c: this.props.fieldJob.How_many_tiles_are_still_needed__c,
        Customer_knows_the_status_of_the_job__c: this.props.fieldJob.Customer_knows_the_status_of_the_job__c,
        Why_customer_doesn_t_know_status_of_job__c: this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c,
        Battery_install_completed__c: this.props.fieldJob.Battery_install_completed__c,
        Roof_conduit_painted__c: this.props.fieldJob.Roof_conduit_painted__c,
        Opti_map_picture_uploaded__c: this.props.fieldJob.Opti_map_picture_uploaded__c,
        Did_the_customer_sign_the_NEM_form__c: this.props.fieldJob.Did_the_customer_sign_the_NEM_form__c,
        Ready_for_final_inspection__c: this.props.fieldJob.Ready_for_final_inspection__c,
        All_Roof_photos_uploaded_cb__c: this.props.fieldJob.All_Roof_photos_uploaded_cb__c,

        Does_the_equipment_installed_match_the_p__c: this.props.fieldJob.Does_the_equipment_installed_match_the_p__c,
        CAD_Errors__c: this.props.fieldJob.CAD_Errors__c,
        Solar_electrical_work_complete__c: this.props.fieldJob.Solar_electrical_work_complete__c,
        What_electrical_work_needs_to_be_comp__c: this.props.fieldJob.What_electrical_work_needs_to_be_comp__c,
        Reason_for_not_completing_SE_work__c: this.props.fieldJob.Reason_for_not_completing_SE_work__c,
        Est_time_needed_to_finish_SE_install__c: this.props.fieldJob.Est_time_needed_to_finish_SE_install__c,
        What_type_of_battery__c: this.props.fieldJob.What_type_of_battery__c,
        Is_customer_registered_with_Tesla__c: this.props.fieldJob.Is_customer_registered_with_Tesla__c,
        Gateway_SN__c: this.props.fieldJob.Gateway_SN__c,
        Tested_battery_backup_for_10_minutes__c: this.props.fieldJob.Tested_battery_backup_for_10_minutes__c,
        Customer_confirmed_circuits__c: this.props.fieldJob.Customer_confirmed_circuits__c,
        Verify_CT_s_are_correct__c: this.props.fieldJob.Verify_CT_s_are_correct__c,
        All_battery_photos_uploaded__c: this.props.fieldJob.All_battery_photos_uploaded__c,
        X120_rule_did_we_setup_the_PCS_feature__c: this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c,
        X3_Foot_Fire_Clearance_Met__c: this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c,
        Customer_registered_during_commissioning__c: this.props.fieldJob.Customer_registered_during_commissioning__c,
        Did_you_have_all_equipment_necessary_E__c: this.props.fieldJob.Did_you_have_all_equipment_necessary_E__c,
        Any_damage_to_siding_stucco__c: this.props.fieldJob.Any_damage_to_siding_stucco__c,
        Able_to_fix_on_site__c: this.props.fieldJob.Able_to_fix_on_site__c,
        Customer_knows_the_status_of_the_job_E__c: this.props.fieldJob.Customer_knows_the_status_of_the_job_E__c,
        Has_the_Derate_been_completed__c: this.props.fieldJob.Has_the_Derate_been_completed__c,
        Why_was_the_derate_not_completed__c: this.props.fieldJob.Why_was_the_derate_not_completed__c,
        Has_the_new_subpanel_been_installed__c: this.props.fieldJob.Has_the_new_subpanel_been_installed__c,
        Has_the_subpanel_been_upgraded__c: this.props.fieldJob.Has_the_subpanel_been_upgraded__c,
        Has_the_SPAN_Panel_been_installed__c: this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c,
        Was_the_transfer_switch_completed__c: this.props.fieldJob.Was_the_transfer_switch_completed__c,
        Has_the_EV_Charger_been_installed__c: this.props.fieldJob.Has_the_EV_Charger_been_installed__c,
        Has_the_220V_outlet_been_installed__c: this.props.fieldJob.Has_the_220V_outlet_been_installed__c,
        Has_breaker_relocation_been_completed__c: this.props.fieldJob.Has_breaker_relocation_been_completed__c,
        Has_other_electrical_work_been_completed__c: this.props.fieldJob.Has_other_electrical_work_been_completed__c,
        Has_power_been_restored_to_the_home__c: this.props.fieldJob.Has_power_been_restored_to_the_home__c,
        Why_was_power_not_restored_to_the_home__c: this.props.fieldJob.Why_was_power_not_restored_to_the_home__c,
        Wall_conduit_painted__c: this.props.fieldJob.Wall_conduit_painted__c,
        Ready_for_final_inspection_E__c: this.props.fieldJob.Ready_for_final_inspection_E__c,
        Final_Solar_Elec_walkthrough_completed__c: this.props.fieldJob.Final_Solar_Elec_walkthrough_completed__c,
        Monitoring_set_up__c: this.props.fieldJob.Monitoring_set_up__c,
        Commissioning_Screen_Shots__c: this.props.fieldJob.Commissioning_Screen_Shots__c,
        All_electrical_photos_uploaded__c: this.props.fieldJob.All_electrical_photos_uploaded__c,
        Solar_Electrician_Notes__c: this.props.fieldJob.Solar_Electrician_Notes__c,
        Has_the_trench_been_completed__c: this.props.fieldJob.Has_the_trench_been_completed__c,
        Trench_Inspection_Outcome__c: this.props.fieldJob.Trench_Inspection_Outcome__c,

        Remaining_Electrical_Work__c: this.props.session.Opportunity__r.Electrical_Work__c !== null ? this.props.session.Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c : null,

        fieldTeam: [],
        assignedCrew: {},
        addidtionalTech: '',
        shouldShowTooltip: false,
        tooltipTitle: '',
        tooltipBody: ''
    };

    saveFields = () => {
        const payload = {...this.state};

        if(this.validationSaveCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;
            delete payload.Remaining_Electrical_Work__c;

            delete payload.fieldTeam;
            delete payload.assignedCrew;
            delete payload.addidtionalTech;
            delete payload.shouldShowTooltip;
            delete payload.tooltipTitle;
            delete payload.tooltipBody;

            if(this.state.fieldTeam.length !== 0){
                console.log(this.props.fieldTeam);
                let values = this.state.fieldTeam;
                let installCrew = '';
                values.forEach(value => {
                    installCrew = installCrew + value + ',';
                });

                if(this.state.addidtionalTech !== ''){
                    installCrew = installCrew + this.state.addidtionalTech;
                }

                payload.Install_Crew__c = installCrew;
            }

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;
            delete payload.Remaining_Electrical_Work__c;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            delete payload.fieldTeam;
            delete payload.assignedCrew;
            delete payload.addidtionalTech;
            delete payload.shouldShowTooltip;
            delete payload.tooltipTitle;
            delete payload.tooltipBody;

            if(this.state.fieldTeam.length !== 0){
                console.log(this.props.fieldTeam);
                let values = this.state.fieldTeam;
                let installCrew = '';
                values.forEach(value => {
                    installCrew = installCrew + value + ',';
                });

                if(this.state.addidtionalTech !== ''){
                    installCrew = installCrew + this.state.addidtionalTech;
                }

                payload.Install_Crew__c = installCrew;
            }

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    validationSaveCheck = (payload) => {
        let valid = true;

        if(payload['Job_Notes__c'] !== null && payload['Job_Notes__c'].length > 5000) {
            this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for Field Notes'})
            valid = false;
        }

        return valid;
    };

    validationCompleteCheck = (payload) => {
        let valid = true;

        if(this.validationSaveCheck(payload)){
            if(this.state.Install_Outcome__c === '' || this.state.Install_Outcome__c === null) {
                this.setState({shouldShowAlert: true, alertMessage: 'Install Outcome needs to be filled out before ending job'});
                valid = false;
            }

            if(this.state.Install_Outcome__c === 'Canceled') {
                if(payload['What_Was_The_Reason_For_Cancelling__c'] === null || payload['Needs_follow_up__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Reason for Cancellation and if Follow up is Needed'});
                    valid = false;
                }
            }

            if(this.state.Install_Outcome__c !== 'Canceled') {
                for (const key in payload) {
                    if(this.reqFields.includes(key)){
                        if(payload[key] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) Before Ending Job'})
                            valid = false;
                            break;
                        }
                    }
                }

                if(this.state.Customer_verbally_approved_layout__c === 'No' && this.state.Why_didn_t_CU_approve_layout__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Customer Did Not Approve Plans'});
                    valid = false;
                }

                if(this.state.Does_the_work_match_the_plans__c === 'No' && this.state.Why_doesn_t_the_work_match_the_plans__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why The Plans Do Not Match'});
                    valid = false;
                }

                if(this.state.Roof_Work_Complete__c === 'No' && (this.state.What_roof_work_needs_to_be_completed_C__c === null || this.state.Reason_for_not_completing_roof_work_C__c === null || this.state.Estimated_time_needed_to_finish_Roof_Ins__c === null || this.state.What_type_of_tech_needs_to_be_sent_out__c === null)){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill In The Additional Roof Work Not Complete Fields'});
                    valid = false;
                }

                if(this.state.Did_you_have_all_equipment_necessary__c === 'No' && this.state.Why_not_supplied_with_all_equipment__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why You Were Not Supplied With Necessary Equipment'});
                    valid = false;
                }

                if(this.state.Any_broken_tiles__c === 'Yes' && this.state.Did_you_have_enough_tiles_to_fix_broken__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select If You Had Tiles To Fix The Broken Ones'});
                    valid = false;
                }

                if(this.state.Customer_knows_the_status_of_the_job__c === 'No' && this.state.Why_customer_doesn_t_know_status_of_job__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Customer Does Not Know Job Status'});
                    valid = false;
                }

                if(this.state.Does_the_equipment_installed_match_the_p__c === 'No' && this.state.CAD_Errors__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select The CAD Errors'});
                    valid = false;
                }

                if(this.state.Does_the_equipment_installed_match_the_p__c === 'No' && this.state.CAD_Errors__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select The CAD Errors'});
                    valid = false;
                }

                if(this.state.Solar_electrical_work_complete__c === 'No' && (this.state.What_electrical_work_needs_to_be_comp__c === null || this.state.Reason_for_not_completing_SE_work__c === null || this.state.What_type_of_tech_needs_to_be_sent_out__c === null || this.state.Est_time_needed_to_finish_SE_install__c === null)){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill In The Additional Solar Work Not Complete Fields'});
                    valid = false;
                }

                if(this.state.Did_you_have_all_equipment_necessary_E__c === 'No' && this.state.Why_not_supplied_with_all_equipment__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why You Were Not Supplied With Necessary Equipment'});
                    valid = false;
                }

                if(this.state.Any_damage_to_siding_stucco__c === 'Yes' && this.state.Able_to_fix_on_site__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Not If You Were Able To Fix Stucco On Site'});
                    valid = false;
                }

                if(this.state.Customer_knows_the_status_of_the_job_E__c === 'No' && this.state.Why_customer_doesn_t_know_status_of_job__c === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Customer Does Not Know Job Status'});
                    valid = false;
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.setState({[field]: this.assignMultiple(event.target.selectedOptions)})} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'checkbox':
                return(
                    <div className="pb-4">
                        <input
                            type="checkbox"
                            defaultChecked={fieldProps ? fieldProps : false}
                            onChange={(event) => this.setState({[field]: !event.target.defaultChecked})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    assignMultiple = (value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        return groupedValues;
    };

    updateFieldTeam = (selectedOptions) => {
        if(selectedOptions.length !== 0){
            let values = [];
            Array.from(selectedOptions).forEach(option => {
                values.push(option.value);
            });

            this.setState({fieldTeam: values});
        }
    };

    setTooltipInfo = (value) => {
        this.setState({shouldShowTooltip: true});

        switch (value) {
            case 'Install_Outcome__c':
                this.setState({
                    tooltipTitle: 'Install Outcome',
                    tooltipBody: 'Full completion: All panels laid, wire pulls done, system commisioned, no need to return<br></br>Partial completion: Some electrical or roof work has been done, but we need to return for follow up'
                })
                break;

            case 'Customer_verbally_approved_layout__c': 
                this.setState({
                    tooltipTitle: 'Did the customer approve plans',
                    tooltipBody: 'Did customer see plans beforehand and approve of placement and layout of all equipment'
                })
                break;

            case 'Does_the_work_match_the_plans__c': 
                this.setState({
                    tooltipTitle: 'Does the work match the plans',
                    tooltipBody: 'Did you make any changes to arrays or equipment on the wall (placement/layout/equipment not needed)'
                })
                break;

            case 'Roof_Work_Complete__c': 
                this.setState({
                    tooltipTitle: 'Roof work complete',
                    tooltipBody: 'All panels laid, wire pulls done, no need to return  All Panels Laid, JBox Wired, Wire Pull Complete, Commissioning Screen Shots (Unless  pending MPU), Photos Approved, [Derate, SubPanel, EV Charger, Transfer Switch, Photos Approved] if needed'
                })
                break;

            case 'What_type_of_tech_needs_to_be_sent_out__c': 
                this.setState({
                    tooltipTitle: 'What type of tech needs to be sent out?',
                    tooltipBody: 'Install crew: Any roof work that still needs to be done besides conduit painting. Finish laying panels, tie in J-Box on roof, strap conduit on roof, wire management, attach punch up, any other roof work besides conduit painting' +
                        '<br></br>Solar electrician: Commision system, tie in' +
                        '<br></br>Battery electrician: Commision system, tie in, transfer loads, back up battery' +
                        '<br></br>Service technician: Conduit painting, inverter replacement, other simple work that would only require one body' +
                        '<br></br>Handyman: Any damage to Customer property including siding'
                })
                break;

            case 'Customer_knows_the_status_of_the_job__c': 
                this.setState({
                    tooltipTitle: 'Customer knows the status of the job?',
                    tooltipBody: 'Does customer know the next step of their project (follow up, handyman, inspection, what was done today)?'
                })
                break;

            case 'Opti_map_picture_uploaded__c': 
                this.setState({
                    tooltipTitle: 'Opti map picture uploaded?',
                    tooltipBody: 'Is it legible?'
                })
                break;

            case 'Ready_for_final_inspection__c': 
                this.setState({
                    tooltipTitle: 'Ready for final inspection?',
                    tooltipBody: 'Inspection will pass, no follow up work needed, work matches plans, no sididng needs to be repaired'
                })
                break;

            case 'All_Roof_photos_uploaded_cb__c': 
                this.setState({
                    tooltipTitle: 'All roof photos uploaded?',
                    tooltipBody: 'RTR will pass'
                })
                break;

            case 'Final_walkthrough_completed_cb__c': 
                this.setState({
                    tooltipTitle: 'Final walkthrough complete?',
                    tooltipBody: 'Walk around customers property, no trash/tools/equipment left behind'
                })
                break;

            case 'Does_the_equipment_installed_match_the_p__c': 
                this.setState({
                    tooltipTitle: 'Does equipment installed match the plans?',
                    tooltipBody: 'Are all wire sizes and electrical equipment sizes installed the same as stated on the plans'
                })
                break;

            case 'Solar_electrical_work_complete__c': 
                this.setState({
                    tooltipTitle: 'Solar Electrical work complete?',
                    tooltipBody: 'All equipment hung/piped/tied in/commissioned; no need for anyone to return for Solar Electrical work'
                })
                break;

            case 'Battery_install_completed__c': 
                this.setState({
                    tooltipTitle: 'Is the battery install complete?',
                    tooltipBody: 'Battery hung, piped, wire pull, commissoned; no need to return for any battery work'
                })
                break;

            case 'Is_customer_registered_with_Tesla__c': 
                this.setState({
                    tooltipTitle: 'Is customer registered with Tesla',
                    tooltipBody: 'Did you get a screen shot of the customers email showing they are registered'
                })
                break;

            case 'Gateway_SN__c': 
                this.setState({
                    tooltipTitle: 'Gateway SN',
                    tooltipBody: 'Serial Number on the side of the Battery'
                })
                break;

            case 'Tested_battery_backup_for_10_minutes__c': 
                this.setState({
                    tooltipTitle: 'Tested battery backup for 10 minutes?',
                    tooltipBody: 'Simulated power outage for 10 min and got pictures'
                })
                break;

            case 'Customer_confirmed_circuits__c': 
                this.setState({
                    tooltipTitle: 'Customer confirmed circuits?',
                    tooltipBody: 'Customer confirmed which circuits will be backed up'
                })
                break;

            case 'Verify_CT_s_are_correct__c': 
                this.setState({
                    tooltipTitle: 'Verify CTs are correct?',
                    tooltipBody: 'Are they facing the correct direction, are they in the correct location, existing solar has CTs on them if applicable (verify by having no negative home loads, Enphase CTs arrows face the loads, existing solar with enphase the CT(2) arrow faces away from breaker and landed as production)'
                })
                break;

            case 'All_battery_photos_uploaded__c': 
                this.setState({
                    tooltipTitle: 'All battery photos uploaded?',
                    tooltipBody: 'RTR will pass'
                })
                break;

            case 'X120_rule_did_we_setup_the_PCS_feature__c': 
                this.setState({
                    tooltipTitle: 'If the sum of the amps for the battery and solar exceeds the 120% rule did we setup the PCS feature?',
                    tooltipBody: 'Did we put in the PCS on what the plans say on the SLD  Does the PCS match the plans?'
                })
                break;

            case 'X3_Foot_Fire_Clearance_Met__c': 
                this.setState({
                    tooltipTitle: '3 foot fire clearance met?',
                    tooltipBody: 'Are the batteries at least 3ft away from doors, windows, and each other?'
                })
                break;

            case 'Customer_registered_during_commissioning__c': 
                this.setState({
                    tooltipTitle: 'Was the customer registered during commissioning?',
                    tooltipBody: 'Did you get a screen shot of the customers email showing they are registered '
                })
                break;

            case 'Any_damage_to_siding_stucco__c': 
                this.setState({
                    tooltipTitle: 'Any damage to siding/stucco?',
                    tooltipBody: 'Does a handyman need to come and repair stucco/siding'
                })
                break;

            case 'Customer_knows_the_status_of_the_job_E__c': 
                this.setState({
                    tooltipTitle: 'Customer knows the status of the job?',
                    tooltipBody: 'Does customer know the next step of their project (follow up, handyman, inspection, what was done today)?'
                })
                break;

            case 'Has_power_been_restored_to_the_home__c': 
                this.setState({
                    tooltipTitle: 'Has power been restored to the home?',
                    tooltipBody: 'Verified that customer circuits AND AC works'
                })
                break;

            case 'Ready_for_final_inspection_E__c': 
                this.setState({
                    tooltipTitle: 'Ready for final inspection?',
                    tooltipBody: 'Inspection will pass, no follow up work needed, work matches plans, no siding needs to be repaired'
                })
                break;

            case 'Final_Solar_Elec_walkthrough_completed__c': 
                this.setState({
                    tooltipTitle: 'Final Solar Electrical walkthrough completed?',
                    tooltipBody: 'Does the customer knows what to expect from their system? Did you explain whether its "backup" vs "time of use", what circuits would be backed up, and if there is an interlock kit, does the customer understand how to use it?'
                })
                break;

            case 'Monitoring_set_up__c': 
                this.setState({
                    tooltipTitle: 'Monitoring set up?',
                    tooltipBody: 'Is the system fully commissoned'
                })
                break;

            case 'Commissioning_Screen_Shots__c': 
                this.setState({
                    tooltipTitle: 'Commissioning screen shots?',
                    tooltipBody: 'All required commissiong screenshots have been taken'
                })
                break;

            case 'All_electrical_photos_uploaded__c': 
                this.setState({
                    tooltipTitle: 'All electrical photos uploaded?',
                    tooltipBody: 'RTR will pass'
                })
                break;

            default:
                break;
        }
    };

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            
            {/* Header of Field Job Form and includes buttons to End Job and Save */}
            <div className="d-flex justify-content-between mt-5 mb-4">
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>
            {/* End of Header */}

            {
                this.state.isEditing ?

                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">Install Field Job</h2>

                    <div className="py-3">
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Add Additional Tech Not On Crew:</label>
                        <Downshift 
                            onChange={selection => this.setState({addidtionalTech: selection.id})}
                            itemToString={item => (item ? item.value : '')}
                        >
                            {({
                                getInputProps,
                                getItemProps,
                                getMenuProps,
                                isOpen,
                                inputValue,
                                highlightedIndex,
                                selectedItem
                            }) => (
                            <div>
                                <div className="w-72 flex flex-col gap-1">
                                    <div className="flex bg-white gap-0.5">
                                        <input className='form-control' placeholder="Type Tech's Name" {...getInputProps()} />
                                    </div>
                                </div>
                                <ul className="list-group" {...getMenuProps()}>
                                    {
                                        isOpen ? 
                                        this.props.activeFieldPersonnel.filter(item => !inputValue || (item.value).toLowerCase().includes(inputValue) || item.value.includes(inputValue))
                                            .map((item, index) => (
                                            <li className="list-group-item" {...getItemProps({key: item.value, index, item,
                                                style: {
                                                    backgroundColor:
                                                    highlightedIndex === index ? 'lightgray' : 'black',
                                                    fontWeight: selectedItem === item ? 'bold' : 'normal',
                                                },
                                                })}
                                            >
                                                {item.value}
                                            </li>
                                        ))
                                        : null
                                    }
                                </ul>
                            </div>
                            )}
                        </Downshift>
                    </div>

                    <div>
                        <label htmlFor="Install_Outcome__c">Install Outcome *</label>
                        <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Install_Outcome__c')} /></span>
                        {this.getInput('picklist', 'Install_Outcome__c', this.state.Install_Outcome__c, this.pickfields.Install_Outcome__c.picklistValues)}
                    </div>

                    {/* For When Field Job Is Cancelled */}
                    <div className={this.state.Install_Outcome__c === 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling? *</label>
                            {this.getInput('picklist', 'What_Was_The_Reason_For_Cancelling__c', this.state.What_Was_The_Reason_For_Cancelling__c, this.pickfields.What_Was_The_Reason_For_Cancelling__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up and service call required? *</label>
                            {this.getInput('yesNo', 'Needs_follow_up__c', this.state.Needs_follow_up__c)}
                        </div>

                        <h2 className="pt-4">Field Notes</h2>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Field Notes</label>
                            {this.getInput('textarea', 'Job_Notes__c', this.state.Job_Notes__c)}
                        </div>
                    </div>
                    {/* End of For When Field Job Is Cancelled */}

                    {/* Not Cancelled */}
                    <div className={this.state.Install_Outcome__c !== 'Canceled' ? '' : 'd-none'}>
                        <h2 className="pt-4">Roof Install Questions</h2>

                        <div>
                            <label className="text-white m-0 py-2">Did the customer approve plans? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Customer_verbally_approved_layout__c')} /></span>
                            {this.getInput('yesNo', 'Customer_verbally_approved_layout__c', this.state.Customer_verbally_approved_layout__c)}
                        </div>

                        {/* Conditional Rendering for Customer_verbally_approved_layout__c */}
                        <div className={this.state.Customer_verbally_approved_layout__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Please select why the customer didn't approve. *</label>
                                {this.getInput('picklist', 'Why_didn_t_CU_approve_layout__c', this.state.Why_didn_t_CU_approve_layout__c, this.pickfields.Why_didn_t_CU_approve_layout__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Customer_verbally_approved_layout__c */}

                        <div>
                            <label className="text-white m-0 py-2">Does the work match the plans? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Does_the_work_match_the_plans__c')} /></span>
                            {this.getInput('yesNo', 'Does_the_work_match_the_plans__c', this.state.Does_the_work_match_the_plans__c)}
                        </div>
                        {/* Conditional Rendering for Does_the_work_match_the_plans__c */}
                        <div className={this.state.Does_the_work_match_the_plans__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Please select why they do not match. (Select all that apply) *</label>
                                {this.getInput('multiPicklist', 'Why_doesn_t_the_work_match_the_plans__c', this.state.Why_doesn_t_the_work_match_the_plans__c, this.pickfields.Why_doesn_t_the_work_match_the_plans__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Does_the_work_match_the_plans__c */}

                        <div>
                            <label className="text-white m-0 py-2">Roof work complete? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Roof_Work_Complete__c')} /></span>
                            {this.getInput('yesNo', 'Roof_Work_Complete__c', this.state.Roof_Work_Complete__c)}
                        </div>
                        {/* Conditional Rendering for Roof_Work_Complete__c */}
                        <div className={this.state.Roof_Work_Complete__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">What roof work needs to be completed? *</label>
                                {this.getInput('picklist', 'What_roof_work_needs_to_be_completed_C__c', this.state.What_roof_work_needs_to_be_completed_C__c, this.pickfields.What_roof_work_needs_to_be_completed_C__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Reason for not completing work? *</label>
                                {this.getInput('picklist', 'Reason_for_not_completing_roof_work_C__c', this.state.Reason_for_not_completing_roof_work_C__c, this.pickfields.Reason_for_not_completing_roof_work_C__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">What type of tech needs to be sent out? *</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('What_type_of_tech_needs_to_be_sent_out__c')} /></span>
                                {this.getInput('multiPicklist', 'What_type_of_tech_needs_to_be_sent_out__c', this.state.What_type_of_tech_needs_to_be_sent_out__c, this.pickfields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Estimated time needed to finish Install *</label>
                                {this.getInput('picklist', 'Estimated_time_needed_to_finish_Roof_Ins__c', this.state.Estimated_time_needed_to_finish_Roof_Ins__c, this.pickfields.Estimated_time_needed_to_finish_Roof_Ins__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Roof_Work_Complete__c */}

                        <div>
                            <label className="text-white m-0 py-2">Were you supplied with all equipment necessary? *</label>
                            {this.getInput('yesNo', 'Did_you_have_all_equipment_necessary__c', this.state.Did_you_have_all_equipment_necessary__c)}
                        </div>

                        {/* Conditional Rendering for Did_you_have_all_equipment_necessary__c */}
                        <div className={this.state.Did_you_have_all_equipment_necessary__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Why were you not supplied with all equipment necessary?</label>
                                {this.getInput('picklist', 'Why_not_supplied_with_all_equipment__c', this.state.Why_not_supplied_with_all_equipment__c, this.pickfields.Why_not_supplied_with_all_equipment__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Did_you_have_all_equipment_necessary__c */}

                        <div>
                            <label className="text-white m-0 py-2">Any broken tiles? *</label>
                            {this.getInput('yesNo', 'Any_broken_tiles__c', this.state.Any_broken_tiles__c)}
                        </div>

                        {/* Conditional Rendering for Any_broken_tiles__c */}
                        <div className={this.state.Any_broken_tiles__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Did you have enough tiles to replace what was broken? *</label>
                                {this.getInput('yesNo', 'Did_you_have_enough_tiles_to_fix_broken__c', this.state.Did_you_have_enough_tiles_to_fix_broken__c)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">How many tiles are still needed?</label>
                                {this.getInput('num', 'How_many_tiles_are_still_needed__c', this.state.How_many_tiles_are_still_needed__c)}
                            </div>
                        </div>
                        {/* End of Any_broken_tiles__c */}

                        <div>
                            <label className="text-white m-0 py-2">Customer knows the status of the job? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Customer_knows_the_status_of_the_job__c')} /></span>
                            {this.getInput('yesNo', 'Customer_knows_the_status_of_the_job__c', this.state.Customer_knows_the_status_of_the_job__c)}
                        </div>
                        {/* Conditional Rendering for Customer_knows_the_status_of_the_job__c */}
                        <div className={this.state.Customer_knows_the_status_of_the_job__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Why does the customer not know the status of the job? (Please leave door sign with the job status) *</label>
                                {this.getInput('picklist', 'Why_customer_doesn_t_know_status_of_job__c', this.state.Why_customer_doesn_t_know_status_of_job__c, this.pickfields.Why_customer_doesn_t_know_status_of_job__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Customer_knows_the_status_of_the_job__c */}

                        <div>
                            <label className="text-white m-0 py-2">Roof conduit painted? *</label>
                            {this.getInput('yesNo', 'Roof_conduit_painted__c', this.state.Roof_conduit_painted__c)}
                        </div>
                        <div>
                            <label className="text-whitem-0 py-2">Opti map picture uploaded? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Opti_map_picture_uploaded__c')} /></span>
                            {this.getInput('yesNo', 'Opti_map_picture_uploaded__c', this.state.Opti_map_picture_uploaded__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">NEM Signed? *</label>
                            {this.getInput('yesNo', 'Did_the_customer_sign_the_NEM_form__c', this.state.Did_the_customer_sign_the_NEM_form__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Ready for final inspection? *</label>
                            <span className="text-primary"><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Ready_for_final_inspection__c')} /></span>
                            {this.getInput('yesNo', 'Ready_for_final_inspection__c', this.state.Ready_for_final_inspection__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">All roof photos uploaded? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('All_Roof_photos_uploaded_cb__c')} /></span>
                            {this.getInput('checkbox', 'All_Roof_photos_uploaded_cb__c', this.state.All_Roof_photos_uploaded_cb__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Final walkthrough completed? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Final_walkthrough_completed_cb__c')} /></span>
                            {this.getInput('checkbox', 'Final_walkthrough_completed_cb__c', this.state.Final_walkthrough_completed_cb__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Roof Lead Notes:</label>
                            {this.getInput('textarea', 'Roof_Lead_Notes__c', this.state.Roof_Lead_Notes__c)}
                        </div>

                        {/* SOLAR ELECTRICAL SECTION */}
                        <h2 className="pt-4">Solar Electrical Questions</h2>

                        <div>
                            <label className="text-white m-0 py-2">Does equipment installed match plans? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Does_the_equipment_installed_match_the_p__c')} /></span>
                            {this.getInput('yesNo', 'Does_the_equipment_installed_match_the_p__c', this.state.Does_the_equipment_installed_match_the_p__c)}
                        </div>
                        {/* Conditional Rendering for Does_the_equipment_installed_match_the_p__c */}
                        <div className={this.state.Does_the_equipment_installed_match_the_p__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">CAD Errors: *</label>
                                {this.getInput('multiPicklist', 'CAD_Errors__c', this.state.CAD_Errors__c, this.pickfields.CAD_Errors__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Does_the_equipment_installed_match_the_p__c */}

                        <div>
                            <label className="text-white m-0 py-2">Solar electrical work complete? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Solar_electrical_work_complete__c')} /></span>
                            {this.getInput('yesNo', 'Solar_electrical_work_complete__c', this.state.Solar_electrical_work_complete__c)}
                        </div>
                        {/* Conditional Rendering for Solar_electrical_work_complete__c */}
                        <div className={this.state.Solar_electrical_work_complete__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">What electrical work needs to be completed? *</label>
                                {this.getInput('multiPicklist', 'What_electrical_work_needs_to_be_comp__c', this.state.What_electrical_work_needs_to_be_comp__c, this.pickfields.What_electrical_work_needs_to_be_comp__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Reason for not completing solar electrical work? *</label>
                                {this.getInput('picklist', 'Reason_for_not_completing_SE_work__c', this.state.Reason_for_not_completing_SE_work__c, this.pickfields.Reason_for_not_completing_SE_work__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">What type of tech needs to be sent out? *</label>
                                {this.getInput('multiPicklist', 'What_type_of_tech_needs_to_be_sent_out__c', this.state.What_type_of_tech_needs_to_be_sent_out__c, this.pickfields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Estimated time needed to finish solar electrical install? *</label>
                                {this.getInput('picklist', 'Est_time_needed_to_finish_SE_install__c', this.state.Est_time_needed_to_finish_SE_install__c, this.pickfields.Est_time_needed_to_finish_SE_install__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Solar_electrical_work_complete__c */}

                        <div>
                            <label className="text-white m-0 py-2">Is the battery install complete? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Battery_install_completed__c')} /></span>
                            {this.getInput('yesNo', 'Battery_install_completed__c', this.state.Battery_install_completed__c)}
                        </div>
                        {/* Conditional Rendering for Battery_install_completed__c */}
                        <div className={this.state.Battery_install_completed__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">What type of battery?</label>
                                {this.getInput('picklist', 'What_type_of_battery__c', this.state.What_type_of_battery__c, this.pickfields.What_type_of_battery__c.picklistValues)}
                            </div>

                            {/* Conditional Rendering for What_type_of_battery__c */}
                            <div className={this.state.What_type_of_battery__c === 'Tesla' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white m-0 py-2">Is customer registered with Tesla?</label>
                                    <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Is_customer_registered_with_Tesla__c')} /></span>
                                    {this.getInput('yesNo', 'Is_customer_registered_with_Tesla__c', this.state.Is_customer_registered_with_Tesla__c)}
                                </div>
                            </div>
                            {/* End of What_type_of_battery__c */}

                            <div>
                                <label className="text-white m-0 py-2">Gateway SN</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Gateway_SN__c')} /></span>
                                {this.getInput('text', 'Gateway_SN__c', this.state.Gateway_SN__c)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Tested battery backup for 10 minutes?</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Tested_battery_backup_for_10_minutes__c')} /></span>
                                {this.getInput('checkbox', 'Tested_battery_backup_for_10_minutes__c', this.state.Tested_battery_backup_for_10_minutes__c)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Customer confirmed circuits?</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Customer_confirmed_circuits__c')} /></span>
                                {this.getInput('checkbox', 'Customer_confirmed_circuits__c', this.state.Customer_confirmed_circuits__c)}
                            </div>
                            <div>
                                <label className="text-white m-0 py-2">Verify CTs are correct?</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Verify_CT_s_are_correct__c')} /></span>
                                {this.getInput('checkbox', 'Verify_CT_s_are_correct__c', this.state.Verify_CT_s_are_correct__c)}
                            </div> 
                            <div>
                                <label className="text-white m-0 py-2">All battery photos uploaded?</label>
                                <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('All_battery_photos_uploaded__c')} /></span>
                                {this.getInput('checkbox', 'All_battery_photos_uploaded__c', this.state.All_battery_photos_uploaded__c)}
                            </div> 

                        </div>
                        {/* End of Battery_install_completed__c */}

                        <div>
                            <label className="text-white m-0 py-2">If the sum of the amps for the battery and solar exceeds the 120% rule did we setup the PCS feature?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('X120_rule_did_we_setup_the_PCS_feature__c')} /></span>
                            {this.getInput('yesNo', 'X120_rule_did_we_setup_the_PCS_feature__c', this.state.X120_rule_did_we_setup_the_PCS_feature__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">3 Foot Fire Clearance Met?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('X3_Foot_Fire_Clearance_Met__c')} /></span>
                            {this.getInput('yesNo', 'X3_Foot_Fire_Clearance_Met__c', this.state.X3_Foot_Fire_Clearance_Met__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Was the customer registered during commissioning?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Customer_registered_during_commissioning__c')} /></span>
                            {this.getInput('yesNo', 'Customer_registered_during_commissioning__c', this.state.Customer_registered_during_commissioning__c)}
                        </div>

                        <div>
                            <label className="text-white m-0 py-2">Did you have all equipment necessary? *</label>
                            {this.getInput('yesNo', 'Did_you_have_all_equipment_necessary_E__c', this.state.Did_you_have_all_equipment_necessary_E__c)}
                        </div>
                        {/* Conditional Rendering for Did_you_have_all_equipment_necessary_E__c */}
                        <div className={this.state.Did_you_have_all_equipment_necessary_E__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Why were you not supplied with all equipment necessary? *</label>
                                {this.getInput('picklist', 'Why_not_supplied_with_all_equipment__c', this.state.Why_not_supplied_with_all_equipment__c, this.pickfields.Why_not_supplied_with_all_equipment__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Did_you_have_all_equipment_necessary_E__c */}

                        <div>
                            <label className="text-white m-0 py-2">Any damage to siding/stucco? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Any_damage_to_siding_stucco__c')} /></span>
                            {this.getInput('yesNo', 'Any_damage_to_siding_stucco__c', this.state.Any_damage_to_siding_stucco__c)}
                        </div>
                        {/* Conditional Rendering for Any_damage_to_siding_stucco__c */}
                        <div className={this.state.Any_damage_to_siding_stucco__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Able to fix on site? *</label>
                                {this.getInput('yesNo', 'Able_to_fix_on_site__c', this.state.Able_to_fix_on_site__c)}
                            </div>
                        </div>
                        {/* End of Any_damage_to_siding_stucco__c */}

                        <div>
                            <label className="text-white m-0 py-2">Customer knows the status of the job? *</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Customer_knows_the_status_of_the_job_E__c')} /></span>
                            {this.getInput('yesNo', 'Customer_knows_the_status_of_the_job_E__c', this.state.Customer_knows_the_status_of_the_job_E__c)}
                        </div>
                        {/* Conditional Rendering for Customer_knows_the_status_of_the_job_E__c */}
                        <div className={this.state.Customer_knows_the_status_of_the_job_E__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Why does the customer not know the status of the job? (Please leave door sign with the job status) *</label>
                                {this.getInput('picklist', 'Why_customer_doesn_t_know_status_of_job__c', this.state.Why_customer_doesn_t_know_status_of_job__c, this.pickfields.Why_customer_doesn_t_know_status_of_job__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Customer_knows_the_status_of_the_job_E__c */}

                        {/* Conditional Rendering for Remaining_Electrical_Work__c */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Derate') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the Derate been completed?</label>
                                {this.getInput('yesNo', 'Has_the_Derate_been_completed__c', this.state.Has_the_Derate_been_completed__c)}
                            </div>
                            <div className={this.state.Has_the_Derate_been_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white m-0 py-2">Why was the derate not completed?</label>
                                    {this.getInput('text', 'Why_was_the_derate_not_completed__c', this.state.Why_was_the_derate_not_completed__c)}
                                </div>
                            </div>
                        </div>
                        {/* End Of Remaining_Electrical_Work__c */}

                        {/* Conditional Rendering for New Subpanel */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('New Subpanel') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the new subpanel been installed?</label>
                                {this.getInput('yesNo', 'Has_the_new_subpanel_been_installed__c', this.state.Has_the_new_subpanel_been_installed__c)}
                            </div>
                        </div>
                        {/* End Of New Subpanel */}

                        {/* Conditional Rendering for Subpanel Upgrade */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Subpanel Upgrade') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the subpanel been upgraded?</label>
                                {this.getInput('yesNo', 'Has_the_subpanel_been_upgraded__c', this.state.Has_the_subpanel_been_upgraded__c)}
                            </div>
                        </div>
                        {/* End Of Subpanel Upgrade */}

                        {/* Conditional Rendering for SPAN Panel */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('SPAN Panel') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the SPAN Panel been installed?</label>
                                {this.getInput('yesNo', 'Has_the_SPAN_Panel_been_installed__c', this.state.Has_the_SPAN_Panel_been_installed__c)}
                            </div>
                        </div>
                        {/* End Of SPAN Panel */}

                        {/* Conditional Rendering for Transfer Switch */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Transfer Switch') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Was the transfer switch completed?</label>
                                {this.getInput('yesNo', 'Was_the_transfer_switch_completed__c', this.state.Was_the_transfer_switch_completed__c)}
                            </div>
                        </div>
                        {/* End Of Transfer Switch */}

                        {/* Conditional Rendering for EV Charger */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('EV Charger') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the EV Charger been installed?</label>
                                {this.getInput('yesNo', 'Has_the_EV_Charger_been_installed__c', this.state.Has_the_EV_Charger_been_installed__c)}
                            </div>
                        </div>
                        {/* End Of EV Charger */}

                        {/* Conditional Rendering for 220V Outlet */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('220V Outlet') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the 220V outlet been installed?</label>
                                {this.getInput('yesNo', 'Has_the_220V_outlet_been_installed__c', this.state.Has_the_220V_outlet_been_installed__c)}
                            </div>
                        </div>
                        {/* End Of 220V Outlet */}

                        {/* Conditional Rendering for Relocating Breakers */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Relocating Breakers') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has breaker relocation been completed?</label>
                                {this.getInput('yesNo', 'Has_breaker_relocation_been_completed__c', this.state.Has_breaker_relocation_been_completed__c)}
                            </div>
                        </div>
                        {/* End Of Relocating Breakers */}

                        {/* Conditional Rendering for Other */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Other') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has other electrical work been completed?</label>
                                {this.getInput('yesNo', 'Has_other_electrical_work_been_completed__c', this.state.Has_other_electrical_work_been_completed__c)}
                            </div>
                        </div>
                        {/* End Of Other */}

                        {/* Conditional Rendering for Trench */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Has the trench been completed?</label>
                                {this.getInput('yesNo', 'Has_the_trench_been_completed__c', this.state.Has_the_trench_been_completed__c)}
                            </div>
                        </div>
                        {/* End Of Trench */}

                        {/* Conditional Rendering for Trench Inspection */}
                        <div className={this.state.Has_the_trench_been_completed__c === 'Yes' || (this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench Inspection')) ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Trench inspection outcome</label>
                                {this.getInput('picklist', 'Trench_Inspection_Outcome__c', this.state.Trench_Inspection_Outcome__c, this.pickfields.Trench_Inspection_Outcome__c.picklistValues)}
                            </div>
                        </div>
                        {/* End Of Trench Inspection */}

                        <div>
                            <label className="text-white m-0 py-2">Has power been restored to the home?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Has_power_been_restored_to_the_home__c')} /></span>
                            {this.getInput('yesNo', 'Has_power_been_restored_to_the_home__c', this.state.Has_power_been_restored_to_the_home__c)}
                        </div>
                        {/* Conditional Rendering for Has_power_been_restored_to_the_home__c */}
                        <div className={this.state.Has_power_been_restored_to_the_home__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white m-0 py-2">Able to fix on site?</label>
                                {this.getInput('multiPicklist', 'Why_was_power_not_restored_to_the_home__c', this.state.Why_was_power_not_restored_to_the_home__c, this.pickfields.Why_was_power_not_restored_to_the_home__c.picklistValues)}
                            </div>
                        </div>
                        {/* End of Has_power_been_restored_to_the_home__c */}

                        <div>
                            <label className="text-white m-0 py-2">Wall conduit painted? *</label>
                            {this.getInput('yesNo', 'Wall_conduit_painted__c', this.state.Wall_conduit_painted__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Ready for final inspection?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Ready_for_final_inspection_E__c')} /></span>
                            {this.getInput('checkbox', 'Ready_for_final_inspection_E__c', this.state.Ready_for_final_inspection_E__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Final Solar Electrical walkthrough completed?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Final_Solar_Elec_walkthrough_completed__c')} /></span>
                            {this.getInput('checkbox', 'Final_Solar_Elec_walkthrough_completed__c', this.state.Final_Solar_Elec_walkthrough_completed__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Monitoring set up?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Monitoring_set_up__c')} /></span>
                            {this.getInput('checkbox', 'Monitoring_set_up__c', this.state.Monitoring_set_up__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Commissioning Screen Shots?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('Commissioning_Screen_Shots__c')} /></span>
                            {this.getInput('checkbox', 'Commissioning_Screen_Shots__c', this.state.Commissioning_Screen_Shots__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">All electrical photos uploaded?</label>
                            <span className="text-primary" style={{ position: 'relative', marginLeft: '8px' }}><FontAwesomeIcon icon={faQuestion} onClick={() => this.setTooltipInfo('All_electrical_photos_uploaded__c')} /></span>
                            {this.getInput('checkbox', 'All_electrical_photos_uploaded__c', this.state.All_electrical_photos_uploaded__c)}
                        </div>
                        <div>
                            <label className="text-white m-0 py-2">Solar Electrician Notes:</label>
                            {this.getInput('textarea', 'Solar_Electrician_Notes__c', this.state.Solar_Electrician_Notes__c)}
                        </div>

                    </div>
                    {/* End of Not Cancelled */}
                </div>

                :

                // RENDER WHEN NOT EDITING
                // 

                <div className="text-white">
                    <h2 className="pt-4">Install Field Job</h2>

                    <label className="col-sm-5 col-12 m-0 py-2">Install Outcome *</label>
                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Install_Outcome__c ? this.props.fieldJob.Install_Outcome__c : '---'}</div>

                    {/* Shown when Canceled */}
                    <div className={this.props.fieldJob.Install_Outcome__c === 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c ? this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needs_follow_up__c ? this.props.fieldJob.Needs_follow_up__c : '---'}</div>
                        </div>

                        <h2 className="pt-4">Field Notes</h2>
                        <div>
                            <label className="text-white col-sm-5 col-6 m-0 py-2">Field Notes</label>
                            <div className={this.props.fieldJob.Job_Notes__c ? "col-12" : "d-inline col-sm-7 col-12"}>{this.props.fieldJob.Job_Notes__c ? this.props.fieldJob.Job_Notes__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Cancelled */}

                    {/* Not Cancelled */}
                    <div className={this.props.fieldJob.Install_Outcome__c !== 'Canceled' ? '' : 'd-none'}>
                        <h2 className="pt-4">Roof Install Questions</h2>

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did the customer approve plans? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_verbally_approved_layout__c ? this.props.fieldJob.Customer_verbally_approved_layout__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Customer_verbally_approved_layout__c */}
                        <div className={this.props.fieldJob.Customer_verbally_approved_layout__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Please select why the customer didn't approve. *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_didn_t_CU_approve_layout__c ? this.props.fieldJob.Why_didn_t_CU_approve_layout__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Customer_verbally_approved_layout__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does the work match the plans? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_the_work_match_the_plans__c ? this.props.fieldJob.Does_the_work_match_the_plans__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Does_the_work_match_the_plans__c */}
                        <div className={this.props.fieldJob.Does_the_work_match_the_plans__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Please select why they do not match</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_doesn_t_the_work_match_the_plans__c ? this.props.fieldJob.Why_doesn_t_the_work_match_the_plans__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Does_the_work_match_the_plans__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Roof work complete? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_Work_Complete__c ? this.props.fieldJob.Roof_Work_Complete__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Roof_Work_Complete__c */}
                        <div className={this.props.fieldJob.Roof_Work_Complete__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What roof work needs to be completed? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_roof_work_needs_to_be_completed_C__c ? this.props.fieldJob.What_roof_work_needs_to_be_completed_C__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Reason for not completing work? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Reason_for_not_completing_roof_work_C__c ? this.props.fieldJob.Reason_for_not_completing_roof_work_C__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What type of tech needs to be sent out? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c ? this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Estimated time needed to finish Install *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Estimated_time_needed_to_finish_Roof_Ins__c ? this.props.fieldJob.Estimated_time_needed_to_finish_Roof_Ins__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Roof_Work_Complete__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Were you supplied with all equipment necessary? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_you_have_all_equipment_necessary__c ? this.props.fieldJob.Did_you_have_all_equipment_necessary__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Did_you_have_all_equipment_necessary__c */}
                        <div className={this.props.fieldJob.Did_you_have_all_equipment_necessary__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why were you not supplied with all equipment necessary? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_not_supplied_with_all_equipment__c ? this.props.fieldJob.Why_not_supplied_with_all_equipment__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Did_you_have_all_equipment_necessary__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Any broken tiles? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Any_broken_tiles__c ? this.props.fieldJob.Any_broken_tiles__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Any_broken_tiles__c */}
                        <div className={this.props.fieldJob.Any_broken_tiles__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Did you have enough tiles to replace what was broken? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_you_have_enough_tiles_to_fix_broken__c ? this.props.fieldJob.Did_you_have_enough_tiles_to_fix_broken__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">How many tiles are still needed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.How_many_tiles_are_still_needed__c ? this.props.fieldJob.How_many_tiles_are_still_needed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Any_broken_tiles__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Customer knows the status of the job? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_knows_the_status_of_the_job__c ? this.props.fieldJob.Customer_knows_the_status_of_the_job__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Customer_knows_the_status_of_the_job__c */}
                        <div className={this.props.fieldJob.Customer_knows_the_status_of_the_job__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why does the customer not know the status of the job? (Please leave door sign with the job status)</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c ? this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Customer_knows_the_status_of_the_job__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Roof conduit painted? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_conduit_painted__c ? this.props.fieldJob.Roof_conduit_painted__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Opti map picture uploaded? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Opti_map_picture_uploaded__c ? this.props.fieldJob.Opti_map_picture_uploaded__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">NEM Signed? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_the_customer_sign_the_NEM_form__c ? this.props.fieldJob.Did_the_customer_sign_the_NEM_form__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Ready for final inspection? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ready_for_final_inspection__c ? this.props.fieldJob.Ready_for_final_inspection__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">All roof photos uploaded? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.All_Roof_photos_uploaded_cb__c ? 'Yes' : !this.props.fieldJob.All_Roof_photos_uploaded_cb__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Final walkthrough completed? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Final_walkthrough_completed_cb__c ? 'Yes' : !this.props.fieldJob.Final_walkthrough_completed_cb__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Lead Notes:</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.Roof_Lead_Notes__c ? this.props.fieldJob.Roof_Lead_Notes__c : '---'}</div>
                        </div>

                        {/* SOLAR ELECTRICAL SECTION */}
                        <h2 className="pt-4">Solar Electrical Questions</h2>

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does equipment installed match plans? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_the_equipment_installed_match_the_p__c ? this.props.fieldJob.Does_the_equipment_installed_match_the_p__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Does_the_equipment_installed_match_the_p__c */}
                        <div className={this.props.fieldJob.Does_the_equipment_installed_match_the_p__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">CAD Errors: *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.CAD_Errors__c ? this.props.fieldJob.CAD_Errors__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Does_the_equipment_installed_match_the_p__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Solar electrical work complete? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Solar_electrical_work_complete__c ? this.props.fieldJob.Solar_electrical_work_complete__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Solar_electrical_work_complete__c */}
                        <div className={this.props.fieldJob.Solar_electrical_work_complete__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What electrical work needs to be completed? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_electrical_work_needs_to_be_comp__c ? this.props.fieldJob.What_electrical_work_needs_to_be_comp__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Reason for not completing solar electrical work? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Reason_for_not_completing_SE_work__c ? this.props.fieldJob.Reason_for_not_completing_SE_work__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What type of tech needs to be sent out? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c ? this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Estimated time needed to finish solar electrical install? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Est_time_needed_to_finish_SE_install__c ? this.props.fieldJob.Est_time_needed_to_finish_SE_install__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Solar_electrical_work_complete__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Is the battery install complete? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Battery_install_completed__c ? this.props.fieldJob.Battery_install_completed__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Battery_install_completed__c */}
                        <div className={this.props.fieldJob.Battery_install_completed__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What type of battery?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_type_of_battery__c ? this.props.fieldJob.What_type_of_battery__c : '---'}</div>
                            </div>
                            {/* Conditional Rendering for What_type_of_battery__c */}
                            <div className={this.props.fieldJob.What_type_of_battery__c === 'Tesla' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Is customer registered with Tesla?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_customer_registered_with_Tesla__c ? this.props.fieldJob.Is_customer_registered_with_Tesla__c : '---'}</div>
                                </div>
                            </div>
                            {/* End of What_type_of_battery__c */}

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Gateway SN</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Gateway_SN__c ? this.props.fieldJob.Gateway_SN__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Tested battery backup for 10 minutes?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Tested_battery_backup_for_10_minutes__c ? 'Yes' : !this.props.fieldJob.Tested_battery_backup_for_10_minutes__c ? 'No' : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Customer confirmed circuits?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_confirmed_circuits__c ? 'Yes' : !this.props.fieldJob.Customer_confirmed_circuits__c ? 'No' : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Verify CTs are correct?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Verify_CT_s_are_correct__c ? 'Yes' : !this.props.fieldJob.Verify_CT_s_are_correct__c ? 'No' : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">All battery photos uploaded?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.All_battery_photos_uploaded__c ? 'Yes' : !this.props.fieldJob.All_battery_photos_uploaded__c ? 'No' : '---'}</div>
                            </div>

                        </div>
                        {/* End of Battery_install_completed__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">If the sum of the amps for the battery and solar exceeds the 120% rule did we setup the PCS feature?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c ? this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">3 Foot Fire Clearance Met?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c ? this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer registered during commissioning?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_registered_during_commissioning__c ? this.props.fieldJob.Customer_registered_during_commissioning__c : '---'}</div>
                        </div>

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did you have all equipment necessary? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_you_have_all_equipment_necessary_E__c ? this.props.fieldJob.Did_you_have_all_equipment_necessary_E__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Did_you_have_all_equipment_necessary_E__c */}
                        <div className={this.props.fieldJob.Did_you_have_all_equipment_necessary_E__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why were you not supplied with all equipment necessary? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_not_supplied_with_all_equipment__c ? this.props.fieldJob.Why_not_supplied_with_all_equipment__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Did_you_have_all_equipment_necessary_E__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Any damage to siding/stucco? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Any_damage_to_siding_stucco__c ? this.props.fieldJob.Any_damage_to_siding_stucco__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Any_damage_to_siding_stucco__c */}
                        <div className={this.props.fieldJob.Any_damage_to_siding_stucco__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Able to fix on site? *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Able_to_fix_on_site__c ? this.props.fieldJob.Able_to_fix_on_site__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Any_damage_to_siding_stucco__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Customer knows the status of the job? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_knows_the_status_of_the_job_E__c ? this.props.fieldJob.Customer_knows_the_status_of_the_job_E__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Customer_knows_the_status_of_the_job_E__c */}
                        <div className={this.props.fieldJob.Customer_knows_the_status_of_the_job_E__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why does the customer not know the status of the job? (Please leave door sign with the job status) *</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c ? this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Customer_knows_the_status_of_the_job_E__c */}

                        {/* Conditional Rendering for Remaining_Electrical_Work__c */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Derate') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the Derate been completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_Derate_been_completed__c ? this.props.fieldJob.Has_the_Derate_been_completed__c : '---'}</div>
                            </div>
                            <div className={this.props.fieldJob.Has_the_Derate_been_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Why was the derate not completed?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_was_the_derate_not_completed__c ? this.props.fieldJob.Why_was_the_derate_not_completed__c : '---'}</div>
                                </div>
                            </div>
                        </div>
                        {/* End of Remaining_Electrical_Work__c */}

                        {/* Conditional Rendering for New Subpanel */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('New Subpanel') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the new subpanel been installed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_new_subpanel_been_installed__c ? this.props.fieldJob.Has_the_new_subpanel_been_installed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of New Subpanel */}

                        {/* Conditional Rendering for Subpanel Upgrade */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Subpanel Upgrade') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the subpanel been upgraded?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_subpanel_been_upgraded__c ? this.props.fieldJob.Has_the_subpanel_been_upgraded__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Subpanel Upgrade */}

                        {/* Conditional Rendering for SPAN Panel */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('SPAN Panel') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the SPAN Panel been installed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c ? this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of SPAN Panel */}

                        {/* Conditional Rendering for Transfer Switch */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Transfer Switch') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Was the transfer switch completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_transfer_switch_completed__c ? this.props.fieldJob.Was_the_transfer_switch_completed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Transfer Switch */}

                        {/* Conditional Rendering for EV Charger */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('EV Charger') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the EV Charger been installed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_EV_Charger_been_installed__c ? this.props.fieldJob.Has_the_EV_Charger_been_installed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of EV Charger */}

                        {/* Conditional Rendering for 220V Outlet */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('220V Outlet') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the 220V outlet been installed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_220V_outlet_been_installed__c ? this.props.fieldJob.Has_the_220V_outlet_been_installed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of 220V Outlet */}

                        {/* Conditional Rendering for Relocating Breakers */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Relocating Breakers') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has breaker relocation been completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_breaker_relocation_been_completed__c ? this.props.fieldJob.Has_breaker_relocation_been_completed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Relocating Breakers */}

                        {/* Conditional Rendering for Other */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Other') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has other electrical work been completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_other_electrical_work_been_completed__c ? this.props.fieldJob.Has_other_electrical_work_been_completed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Other */}

                        {/* Conditional Rendering for Trench */}
                        <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Has the trench been completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_trench_been_completed__c ? this.props.fieldJob.Has_the_trench_been_completed__c : '---'}</div>
                            </div>
                        </div>
                        {/* End Of Trench */}

                        {/* Conditional Rendering for Trench Inspection */}
                        <div className={this.props.fieldJob.Has_the_trench_been_completed__c === 'Yes' || (this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench Inspection')) ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Trench inspection outcome</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Trench_Inspection_Outcome__c ? this.props.fieldJob.Trench_Inspection_Outcome__c : '---'}</div>
                            </div>
                        </div>
                        {/* End Of Trench Inspection */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has power been restored to the home?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_power_been_restored_to_the_home__c ? this.props.fieldJob.Has_power_been_restored_to_the_home__c : '---'}</div>
                        </div>
                        {/* Conditional Rendering for Has_power_been_restored_to_the_home__c */}
                        <div className={this.props.fieldJob.Has_power_been_restored_to_the_home__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why was power not restored to the home?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_was_power_not_restored_to_the_home__c ? this.props.fieldJob.Why_was_power_not_restored_to_the_home__c : '---'}</div>
                            </div>
                        </div>
                        {/* End of Has_power_been_restored_to_the_home__c */}

                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Wall conduit painted? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Wall_conduit_painted__c ? this.props.fieldJob.Wall_conduit_painted__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Ready for final inspection?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ready_for_final_inspection_E__c ? 'Yes' : !this.props.fieldJob.Ready_for_final_inspection_E__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Final Solar Electrical walkthrough completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Final_Solar_Elec_walkthrough_completed__c ? 'Yes' : !this.props.fieldJob.Final_Solar_Elec_walkthrough_completed__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Monitoring set up?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Monitoring_set_up__c ? 'Yes' : !this.props.fieldJob.Monitoring_set_up__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Commissioning Screen Shots?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Commissioning_Screen_Shots__c ? 'Yes' : !this.props.fieldJob.Commissioning_Screen_Shots__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">All electrical photos uploaded?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.All_electrical_photos_uploaded__c ? 'Yes' : !this.props.fieldJob.All_electrical_photos_uploaded__c ? 'No' : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Solar Electrician Notes:</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.Solar_Electrician_Notes__c ? this.props.fieldJob.Solar_Electrician_Notes__c : '---'}</div>
                        </div>

                    </div>
                    {/* End of Not Cancelled */}
                </div>
            }

            {/* Footer of Field Job Form that includs the buttons for Endind and Saving Job */}
            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

            {/* ---------- Cancel Pending Modal: ---------- */}
            <Modal
                isOpen={this.state.shouldShowTooltip}
                onRequestClose={() => this.setState({
                    shouldShowTooltip: false
                })}
                className="ReactModal"
                overlayClassName="ReactModal__Overlay"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(255, 255, 255, 0.75)'
                    },
                    content: {
                        background: 'rgba(53, 53, 53)',
                    }
                }}
            >
                <div className="d-flex justify-content-between text-white">
                    <h3>{this.state.tooltipTitle}</h3>
                    <span className="mx-2 cursor-pointer">
                        <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                            shouldShowTooltip: false
                        })} />
                    </span>
                </div>

                <div className="mt-3 text-white">
                    <p dangerouslySetInnerHTML={{__html: this.state.tooltipBody}}></p>
                </div>

                <div className="mt-3 text-right text-white">
                    <button className="btn btn-primary" type="button" disabled={this.state.disableCancelPending} onClick={() => this.setState({shouldShowTooltip: false})}>Close</button>
                </div>
            </Modal>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(InstallForm);